/* PA Card — mobile swipe + (+) sizes overlay */

(function () {
  /* Las rutas del carrito llevan el prefijo del mercado (/en-ca/, /es/...). Con la
     ruta absoluta, Shopify redirige y en algunos mercados se pierde la peticion. */
  function cartRoute(path) {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    return `${normalizedRoot}${String(path || '').replace(/^\/+/, '')}`;
  }

  function setupCard(card) {
    if (card.__paCardInit) return;
    card.__paCardInit = true;

    const slider = card.querySelector('[data-card-slider]');
    const track = card.querySelector('[data-card-track]');
    const dots = card.querySelectorAll('[data-card-dots] [data-dot]');
    const plus = card.querySelector('[data-card-plus]');
    const cart = card.querySelector('[data-card-cart]');
    const overlay = card.querySelector('[data-card-sizes-overlay]');
    const link = card.querySelector('[data-card-link]');

    /* Open/close the sizes overlay (shared by the mobile (+) button and the
       desktop round cart button). */
    function openSizes() {
      card.setAttribute('data-sizes-open', '');
      if (plus) plus.setAttribute('aria-expanded', 'true');
      if (cart) cart.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'false');
    }
    function closeSizes() {
      card.removeAttribute('data-sizes-open');
      if (plus) plus.setAttribute('aria-expanded', 'false');
      if (cart) cart.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
    }

    /* Update dots while scrolling track */
    if (track && dots.length) {
      const realSlides = track.querySelectorAll('.pa-card__slide');
      const numReal = realSlides.length;

      /* Infinite loop: clone the first slide at the end so scrolling past
         the last wraps back to the first silently. */
      let cloneSlide = null;
      if (numReal > 1) {
        cloneSlide = realSlides[0].cloneNode(true);
        cloneSlide.classList.add('pa-card__slide--clone');
        cloneSlide.removeAttribute('data-slide');
        cloneSlide.setAttribute('aria-hidden', 'true');
        track.appendChild(cloneSlide);
      }

      let raf;
      let resetTimer;
      track.addEventListener('scroll', () => {
        if (!raf) {
          raf = requestAnimationFrame(() => {
            let idx = Math.round(track.scrollLeft / track.clientWidth);
            if (cloneSlide && idx >= numReal) idx = 0;
            dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
            raf = null;
          });
        }
        if (cloneSlide) {
          clearTimeout(resetTimer);
          resetTimer = setTimeout(() => {
            const slideWidth = track.clientWidth;
            if (track.scrollLeft >= slideWidth * numReal - 2) {
              const prev = track.style.scrollBehavior;
              track.style.scrollBehavior = 'auto';
              track.scrollLeft = 0;
              /* Force a reflow before restoring smooth behavior */
              void track.offsetWidth;
              track.style.scrollBehavior = prev || '';
            }
          }, 80);
        }
      }, { passive: true });

      /* Click a dot to jump to that slide (block link navigation) */
      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const idx = parseInt(dot.dataset.dot, 10);
          if (isNaN(idx)) return;
          const slideWidth = track.clientWidth;
          track.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
        });
      });
    }

    /* Inyectar flechas prev/next sutiles sobre la imagen (sólo si hay >1 imagen) */
    if (track) {
      const allSlides = track.querySelectorAll('.pa-card__slide:not(.pa-card__slide--clone)');
      const media = card.querySelector('.pa-card__media');
      if (media && allSlides.length > 1 && !card.__paImgArrows) {
        card.__paImgArrows = true;
        card.classList.add('pa-card--image-carousel');
        const mkArrow = (dir, label, path) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'pa-card__img-arrow pa-card__img-arrow--' + dir;
          b.setAttribute('aria-label', label);
          b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + path + '"/></svg>';
          return b;
        };
        const prevArrow = mkArrow('prev', 'Imagen anterior', '15 18 9 12 15 6');
        const nextArrow = mkArrow('next', 'Imagen siguiente', '9 6 15 12 9 18');
        const total = allSlides.length;
        const goImg = (delta) => {
          const w = track.clientWidth;
          if (!w) return;
          const current = Math.round(track.scrollLeft / w);
          let target = current + delta;
          if (target < 0) target = total - 1;
          if (target >= total) target = 0;
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        };
        const stopEvt = (e) => { e.preventDefault(); e.stopPropagation(); };
        prevArrow.addEventListener('click', e => { stopEvt(e); goImg(-1); });
        nextArrow.addEventListener('click', e => { stopEvt(e); goImg(+1); });
        media.appendChild(prevArrow);
        media.appendChild(nextArrow);
      }
    }

    /* (+) button (mobile) and round cart button (desktop, sizes mode) both
       toggle the sizes overlay. Prevent navigating the link. */
    if (overlay) {
      [plus, cart].forEach((trigger) => {
        if (!trigger) return;
        /* The cart button in single-variant mode adds directly (data-quick-buy)
           and must not toggle the overlay. */
        if (trigger === cart && !cart.hasAttribute('data-card-cart')) return;
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (card.hasAttribute('data-sizes-open')) closeSizes();
          else openSizes();
        });
      });
      /* Tap/click outside the size grid (still inside the card) closes it */
      card.addEventListener('click', (e) => {
        if (!card.hasAttribute('data-sizes-open')) return;
        if (e.target.closest('[data-card-plus]')) return;
        if (e.target.closest('[data-card-cart]')) return;
        if (e.target.closest('.pa-card__size')) return;
        if (e.target.closest('[data-card-sizes-overlay]') && !e.target.closest('.pa-card__sizes-grid')) {
          e.preventDefault();
          e.stopPropagation();
          closeSizes();
        }
      });
      /* Desktop: leaving the card closes the overlay */
      card.addEventListener('mouseleave', () => {
        if (card.hasAttribute('data-sizes-open')) closeSizes();
      });
    }

    /* Block link navigation when overlay is open */
    if (link) {
      link.addEventListener('click', (e) => {
        if (card.hasAttribute('data-sizes-open')) {
          e.preventDefault();
        }
      });
    }

    /* Quick-buy: clicking a size button adds variant to cart and opens drawer */
    card.querySelectorAll('[data-quick-buy]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        const id = btn.dataset.variantId;
        if (!id) return;
        btn.disabled = true;
        /* Class-based loading state so we don't clobber icon-only buttons. */
        btn.classList.add('is-loading');
        try {
          const item = { id: parseInt(id, 10), quantity: 1 };
          const preorderPropertyName = card.dataset.preorderPropertyName;
          const preorderPropertyValue = card.dataset.preorderPropertyValue;
          if (preorderPropertyName && preorderPropertyValue) {
            item.properties = { [preorderPropertyName]: preorderPropertyValue };
          }
          const res = await fetch(cartRoute('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] }),
          });
          if (!res.ok) throw new Error('add failed');
          /* Close overlay if it was open */
          if (overlay) closeSizes();
          /* Refresh + open cart drawer */
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            if (typeof drawer.refresh === 'function') await drawer.refresh();
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          console.error('Quick-buy failed', err);
        } finally {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-card]').forEach(setupCard);
  }

  window.shopifyReinitCards = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  /* Re-init on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
